import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'custom-input-simple',
  templateUrl: './custom-input-simple.component.html',
  styleUrls: ['./custom-input-simple.component.css']
})
export class CustomInputSimpleComponent {
  @Input() value : string = '';
  @Input() label : boolean = false;
  @Input() labelValue: string = '';
  @Input() placeholder: string = '';
  @Output() parentFunction = new EventEmitter<string>();

  valueChange(newValue:any) {
    this.parentFunction.emit(newValue.target.value)
    this.value = '';
  }
}
